import { useEffect } from 'react';

const DEFAULT_IMAGE = 'https://assets.auxodev.dk/assets/9badcd2d-12ea-450b-8280-42a177052604/chatgpt-image-18-2-3-2026-3-08-35-06.png';

function setMetaTag(nameOrProperty, key, value) {
  if (!value) return;
  let element = document.querySelector(`meta[${nameOrProperty}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(nameOrProperty, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', value);
}

export default function SEOHead({ title, description, image = DEFAULT_IMAGE, ogType = 'website' }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMetaTag('property', 'og:title', title);
      setMetaTag('name', 'twitter:title', title);
    }
    if (description) {
      setMetaTag('name', 'description', description);
      setMetaTag('property', 'og:description', description);
      setMetaTag('name', 'twitter:description', description);
    }
    if (image) {
      setMetaTag('property', 'og:image', image);
      setMetaTag('name', 'twitter:image', image);
    }
    if (ogType) {
      setMetaTag('property', 'og:type', ogType);
    }
    setMetaTag('name', 'twitter:card', 'summary_large_image');
  }, [title, description, image, ogType]);

  return null;
}
